import React, { Fragment } from 'react';
import { useTranslations } from 'use-intl';
import { LabelProps } from './types';

const Label = ({
  children,
  required,
  showOptionalLabel,
  optionalLabel,
  requiredStyle = 'asterisk',
  htmlFor,
}: React.PropsWithChildren<LabelProps>) => {
  const translate = useTranslations();

  if (!children && !required) return <></>;

  return (
    <Fragment>
      {children && (
        <div className="mb-2 flex items-center justify-between">
          <label aria-label={htmlFor} data-testid="label" htmlFor={htmlFor} className="text-14 block">
            <span className="text-gray-700">{children}</span>{' '}
            {!required && showOptionalLabel && (
              <span className="text-gray-400 lowercase">({optionalLabel ?? translate('common.optional')})</span>
            )}
            {required && requiredStyle === 'asterisk' && <span>*</span>}
          </label>
        </div>
      )}
      {required && requiredStyle === 'label' && (
        <div className="mb-2 flex items-center justify-between">
          <span className="text-12 text-gray-500">{translate('common.field-required')}</span>
        </div>
      )}
    </Fragment>
  );
};

export default Label;
